var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"plain-button md:absolute md:mr-6 md:mt-6 mb-6 pin-t pin-r mg-color-accent-2 hover:mg-color-accent-2-light",on:{"click":function($event){$event.preventDefault();_vm.reset($event)}}},[_c('svg',{staticClass:"mg-icon mg-icon--medium"},[_c('use',{attrs:{"href":"#icon-reset","xlink:href":"#icon-reset"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d0ff583","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue-components/card-feed-reset.vue
// module id = 381
// module chunks = 0